<div>
  <div>
    <mat-horizontal-stepper #stepper [linear]="true" [selectedIndex]="2" labelPosition="bottom"
      class="stepper-container stepper-disabled-steps">
      <!-- Step 1: visible, not clickable -->
      <mat-step [editable]="false" [completed]="true">
        <ng-template matStepLabel>Grunddaten</ng-template>
        <div class="step-disabled-info">Dieser Schritt ist deaktiviert.</div>
      </mat-step>

      <!-- Step 2: visible, not clickable -->
      <mat-step [editable]="false" [completed]="true">
        <ng-template matStepLabel>Gallerie & Dateien</ng-template>
        <div class="step-disabled-info">Dieser Schritt ist deaktiviert.</div>
      </mat-step>

      <!-- Step 3: Version -->
      <mat-step [completed]="isFormValid === true">
        <ng-template matStepLabel>{{ stepThreeHeader }}</ng-template>
        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <div></div>
          <button matButton="elevated" color="accent"
            (click)="openProductDetailsPageDialog('Produktübersicht')"
            [disabled]="!isFormValid">
            <mat-icon>crop_free</mat-icon>Vorschau
          </button>
        </div>
        <app-version-edit [version]="version" [dataType]="'PRODUCT_VERSION'" [isCreateNew]="isCreateNew"
          (validityChanged)="onValidityChanged($event)"></app-version-edit>
        <div class="mini-grid-buttons">
          <span class="info-txt">*Pflichtfeld</span>
          <button matButton="elevated" color="warn" (click)="cancelCreateVersion()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <div></div>
          <button [disabled]="!isFormValid" matButton="elevated" class="green-confirm" (click)="stepper.selectedIndex = 4"
            style="margin-top: 1vw;">Weiter</button>
        </div>
      </mat-step>

      <!-- Step 4: visible, not clickable -->
      <mat-step [editable]="false"  [completed]="true">
        <ng-template matStepLabel>Übergeordnete Auswahlkriterien</ng-template>
        <div class="step-disabled-info">Dieser Schritt ist deaktiviert.</div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Zusammenfassung</ng-template>

        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <button id="savebtn" matButton="elevated" color="accent" (click)="createVersion()">
            Speichern
          </button>
          <button matButton="elevated" color="accent"
            (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon>Vorschau
          </button>

        </div>

        <p class="info-text"><em>Bitte drücken Sie den Vorschau-Button um die Änderungen zu prüfen.</em></p>

        <div class="mini-grid-buttons">
          <button matButton="elevated" color="warn" (click)="cancelCreateVersion()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <div></div>
          <button matButton="elevated" class="green-confirm" style="margin-top: 1vw;"
            (click)="stepper.selectedIndex = 2">Zurück</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
<ng-template #loading>
  <p>Loading data</p>
</ng-template>